import { Inject, Injectable, Injector, Optional, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DataTestDialog, DATA_TEST_DIALOG_COMPONENT } from '../../api/data-test-dialog.injection-token';
import { DataTestDialogData } from './data-test-dialog.model';

export interface DataTestDialogParams {
  path: string;
}

@Injectable()
export class DataTestDialogService {
  constructor(
    @Optional() @Inject(DATA_TEST_DIALOG_COMPONENT) private readonly dataTestDialogComponent: Type<DataTestDialog>,
    private readonly injector: Injector,
    private readonly dialog: MatDialog,
  ) {}

  open(params: DataTestDialogParams): Observable<void> {
    if (!this.dataTestDialogComponent) {
      throw new Error('[DataTestDialogService.open]: dataTestDialogComponent is not provided');
    }
    return this.dialog
      .open<DataTestDialog, DataTestDialogData, void>(this.dataTestDialogComponent, {
        width: '90vw',
        height: '90vh',
        data: {
          path: params.path,
        },
        injector: this.injector,
      })
      .afterClosed();
  }
}
